module.exports = __webpack_public_path__ + "static/media/reduce-size.e7102ac1.svg";